import { ChatState, IChat } from "./chat.state";
import AnyAction from "store/anyActions";
import ChatTypes from "./chat.types";
import { DPAResult } from "store/contact/contact.state";
import { EditorState } from "draft-js";

const defaultState: ChatState = {
    connections: [],
    quickReplies: undefined,
    quickRepliesLoading: false,
}

export default function (state: ChatState = defaultState, action: AnyAction): ChatState {

    const replaceConnection = (id: string, newConnection: Partial<IChat>,) => {
        return state.connections.map(c =>
            c.id === id ? {
                ...c,
                ...newConnection
            } : c
        )

    }
    switch (action.type) {
        case ChatTypes.SET_SELECTED_CHAT:
            return {
                ...state,
                selectedChatId: action.payload!,
            };
        // return {
        //     ...state,
        //     connections: state.connections.map(c =>
        //         c.id === action.payload
        //             ? { ...c, unread: 0 }
        //             : c
        //     )
        // }
        case ChatTypes.UPDATE_CONNECTION_EDITOR_CONTENT:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload.id
                        ? { ...c, currentEditorContent: action.payload.content }
                        : c
                )

            }
        case ChatTypes.SEND_CHAT_MESSAGE:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload.id
                        ? { ...c, currentEditorContent: action.payload.clearEditor ? EditorState.createEmpty() : c.currentEditorContent }
                        : c
                )
            }
        case ChatTypes.CLEAR_UNREAD:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload
                        ? { ...c, unread: 0 }
                        : c
                )
            }
        case ChatTypes.ADD_CHAT_CONNECTION:
            return {
                ...state,
                connections: [
                    ...state.connections,
                    action.payload,
                ]
            }
        case ChatTypes.CHAT_ACW:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload
                        ? { ...c, acw: true, acwStartedAt: Date.now(), status: connect.ContactStateType.ENDED }
                        : c
                )
            }
        case ChatTypes.CHAT_ACW_EXTEND:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload
                        ? { ...c, acwExtendedAt: Date.now() }
                        : c
                )
            }
        case ChatTypes.END_CHAT:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload
                        ? { ...c, status: connect.ContactStateType.ENDED }
                        : c
                )
            }

        // case ChatTypes.CHAT_INCOMING:
        //     return state.map(c =>
        //         c.id === action.payload
        //             ? { ...c, status: connect.ContactStateType.INCOMING }
        //             : c
        //     )
        case ChatTypes.CHAT_CONNECTED:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload
                        ? { ...c, status: connect.ContactStateType.CONNECTED }
                        : c
                )
            }
        case ChatTypes.CHAT_DISCONNECTED:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload
                        ? { ...c, status: connect.ContactStateType.ENDED }
                        : c
                )
            }
        case ChatTypes.REMOVE_CHAT_CONNECTION:
            return {
                ...state,
                connections: state.connections.filter(c => c.id !== action.payload)
            }
        //This reducer need for removing chat connection from store without following .destroy() api call
        // which present in listener on REMOVE_CHAT_CONNECTION action
        case ChatTypes.CLEAR_CHAT_CONNECTION:
            return {
                ...state,
                connections: state.connections.filter(c => c.id !== action.payload),
            };
        case ChatTypes.RECIEVE_CHAT_MESSAGE:
            const newMessages = [action.payload.msg].flat();
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload.id
                        ? {
                            ...c,
                            unread: newMessages.slice(-1)[0].ParticipantRole === "AGENT" ? c.unread : c.unread + 1,
                            isTyping: newMessages.slice(-1)[0].ParticipantRole === "CUSTOMER" ? false : c.isTyping,
                            messages: [...c.messages, ...newMessages]
                        }
                        : c
                )
            }
        case ChatTypes.CHAT_MISSED:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload
                        ? { ...c, status: connect.ContactStateType.MISSED, unread: 0 }
                        : c
                )
            }

        case ChatTypes.COMPLETE_CHAT_ACW:
            return {
                ...state,
                connections: state.connections.filter(c => c.id !== action.payload)
            }

        case ChatTypes.RECOVER_CHATS:
            return {
                ...state,
                connections: action.payload
            }
        case ChatTypes.SET_UNREAD_CHATS:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload.id
                        ? {
                            ...c,
                            unread: action.payload.unread,
                        }
                        : c
                )
            }
        case ChatTypes.CHAT_CONTACT_IS_TYPING:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload.id
                        ? {
                            ...c,
                            isTyping: action.payload.typing,
                        }
                        : c
                )
            }
        case ChatTypes.MARK_CHAT_MESSAGE_RECEIPTS_AS_READ:
            return {
                ...state,
            }
        case ChatTypes.GET_QUICK_REPLIES_LOADING:
            return {
                ...state,
                quickRepliesLoading: true
            }
        case ChatTypes.GET_QUICK_REPLIES:
            return {
                ...state,
                quickReplies: { ...state.quickReplies, ...action.payload },
                quickRepliesLoading: false
            }
        case ChatTypes.UPDATE_DPA_CHAT:
            return {
                ...state,
                connections: state.connections.map<IChat>(c => {
                    if (c.id !== action.payload.id) return c;
                    if (!c.DPA) return c;

                    return {
                        ...c,
                        DPA: {
                            ...c.DPA,
                            checks: c.DPA?.checks.map((check: any) => {
                                if (check.label === action.payload.check.label)
                                    return action.payload.check
                                else
                                    return check;
                            })
                        }
                    }
                })
            }
        case ChatTypes.UPDATE_DPA_RESULT_CHAT:
            return {
                ...state,
                connections: state.connections.map(c => {
                    if (c.id !== action.payload.id) return c;
                    if (!c.DPA) return c;

                    return {
                        ...c,
                        DPA: {
                            ...c.DPA,
                            result: action.payload.result
                        }
                    }
                })
            }
        case ChatTypes.UPDATE_AGENT_DPA_CHAT:
            return {
                ...state,
                connections: state.connections.map(c => {
                    if (c.id !== action.payload.id) return c;
                    if (!c.DPA) return c;

                    return {
                        ...c,
                        DPA: {
                            ...c.DPA,
                            agentCheck: action.payload.check,
                            result: action.payload.check.passed ? DPAResult['agent-overall-passed'] : DPAResult['failed']
                        }
                    }

                })
            }
        case ChatTypes.SET_CHAT_REPLY_TEXT:
            return {
                ...state,
                connections: state.connections.map(c => {
                    if (c.id !== action.payload.id) return c;
                    return {
                        ...c,
                        reply: action.payload
                    }
                })
            }
        case ChatTypes.UPDATE_NOTE:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload.id
                        ? {
                            ...c,
                            'sa-acw-notes': action.payload.note,
                            'sa-notes': action.payload.note,
                        }
                        : c
                ),
            };
        case ChatTypes.SEND_ATTACHMENT:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload.id
                        ? {
                            ...c,
                            currentEditorContent: EditorState.createEmpty(),
                            attachments: {
                                ...c.attachments,
                                files: [],
                            }
                        }
                        : c
                )
            }

        case ChatTypes.SET_CUSTOMER_INITIALLY_ACTIVE:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload
                        ? {
                            ...c,
                            customerActive: true
                        }
                        : c
                )
            }
        case ChatTypes.DELETE_ATTACHMENT:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload.id
                        ? {
                            ...c,
                            attachments: {
                                ...c.attachments,
                                files: c.attachments.files.filter((_, i) => action.payload.index !== i)
                            }
                        }
                        : c
                )
            }
        case ChatTypes.SET_ATTACHMENT:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload.id
                        ? {
                            ...c,
                            attachments: {
                                ...c.attachments,
                                files: action.payload.files.map(f => ({
                                    file: f,
                                    loadingState: "waiting"
                                }))
                            }
                        }
                        : c
                )
            }
        case ChatTypes.SET_ATTACHMENT_LOADING:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload.id
                        ? {
                            ...c,
                            attachments: {
                                ...c.attachments,
                                files: c.attachments.files.map((file, i) => (
                                    action.payload.index === i || action.payload.index === undefined
                                        ? { ...file, loadingState: action.payload.state }
                                        : file
                                )

                                )
                            }
                        }
                        : c
                )
            }
        case ChatTypes.SET_DELIVERED_TIMESTAMP:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload.chatId
                        ? {
                            ...c,
                            messages: c.messages.map(message => ({
                                ...message,
                                deliveredTimestamp: message.deliveredTimestamp ? message.deliveredTimestamp : action.payload.timestamp
                            }))
                        }
                        : c
                )
            }
        case ChatTypes.SET_READ_TIMESTAMP:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload.chatId
                        ? {
                            ...c,
                            messages: c.messages.map(message => ({
                                ...message,
                                readTimestamp: message.readTimestamp ? message.readTimestamp : action.payload.timestamp
                            }))
                        }
                        : c
                )
            }

        default:
            return state;
    }
}
